(() => {
  const launcherSelectors = [
    '[data-testid="chat-toggle"]',
    '[data-shopify-chat-button]',
    '#ShopifyChat button',
    '#tidio-chat',
    'iframe[title*="chat" i]',
    'iframe[title*="atendimento" i]',
    '#smile-ui-lite-launcher-frame-container',
    '.smile-launcher-frame-container',
    '[class*="loyalty-launcher" i]',
    '[class*="rewards-launcher" i]',
    '[data-loox-button]',
    '[class*="loox-float" i]'
  ];
  const stickySelectors = [
    '[data-av-sticky-cart]',
    '[data-sticky-cart]',
    '[data-sticky-add-to-cart]',
    '[data-av35-sticky]',
    '.au-floatbar',
    '.product__submit__holder.is-sticky'
  ];
  const launcherSelector = launcherSelectors.join(',');
  const stickySelector = stickySelectors.join(',');
  const watchedSelector = `${launcherSelector},${stickySelector}`;
  const trackedNodes = new WeakSet();
  let frame = 0;
  const observerOptions = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'hidden', 'open', 'style']
  };

  const visible = (node) => {
    if (!(node instanceof HTMLElement)) return false;
    const style = getComputedStyle(node);
    const box = node.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && box.width > 0 && box.height > 0;
  };

  const setData = (node, key, value) => {
    if (node.dataset[key] !== value) node.dataset[key] = value;
  };

  const touchesWatchedUi = (candidate) => {
    const node = candidate instanceof Element ? candidate : candidate?.parentElement;
    if (!node) return false;
    return trackedNodes.has(node)
      || node.matches(watchedSelector)
      || Boolean(node.closest(watchedSelector))
      || Boolean(node.querySelector(watchedSelector));
  };

  const coordinate = () => {
    frame = 0;
    observer.disconnect();
    try {
      const launcherNodes = [...document.querySelectorAll(launcherSelector)];
      launcherNodes.forEach((node) => trackedNodes.add(node));
      const launchers = launcherNodes
        .filter(visible)
        .filter((node) => !node.closest('[role="dialog"], [aria-modal="true"]'));
      let rightIndex = 0;
      [...new Set(launchers)].forEach((node) => {
        setData(node, 'avFloatingUi', 'true');
        if (node.id === 'tidio-chat') {
          setData(node, 'avFloatingRole', 'chat-shell');
        } else if (node.id === 'smile-ui-lite-launcher-frame-container' || node.classList.contains('smile-launcher-frame-container')) {
          setData(node, 'avFloatingRole', 'left');
        } else {
          setData(node, 'avFloatingRole', 'right');
          const nextIndex = String(rightIndex);
          if (node.style.getPropertyValue('--av-floating-index') !== nextIndex) {
            node.style.setProperty('--av-floating-index', nextIndex);
          }
          rightIndex += 1;
        }
      });

      const stickyNodes = [...document.querySelectorAll(stickySelector)];
      stickyNodes.forEach((node) => trackedNodes.add(node));
      const stickyNode = stickyNodes.find(visible);
      const stickyVisible = Boolean(stickyNode);
      setData(document.body, 'avStickyPurchase', String(stickyVisible));
      if (stickyNode) {
        const stickyHeight = Math.min(Math.ceil(stickyNode.getBoundingClientRect().height) + 12, 280);
        const nextOffset = `${stickyHeight}px`;
        if (document.body.style.getPropertyValue('--av-overlay-sticky-offset') !== nextOffset) {
          document.body.style.setProperty('--av-overlay-sticky-offset', nextOffset);
        }
      } else if (document.body.style.getPropertyValue('--av-overlay-sticky-offset')) {
        document.body.style.removeProperty('--av-overlay-sticky-offset');
      }
    } finally {
      observer.observe(document.body, observerOptions);
    }
  };

  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(coordinate);
  };

  const observer = new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) => {
      if (mutation.type === 'attributes') return touchesWatchedUi(mutation.target);
      return touchesWatchedUi(mutation.target)
        || [...mutation.addedNodes, ...mutation.removedNodes].some(touchesWatchedUi);
    });
    if (relevant) schedule();
  });
  const start = () => {
    observer.observe(document.body, observerOptions);
    addEventListener('resize', schedule, { passive: true });
    addEventListener('shopify:section:load', schedule);
    schedule();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
